var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/playVideo.1b3eeb33.png","uri@2x": __webpack_public_path__ + "static/media/playVideo.6b3be32f.png","uri@3x": __webpack_public_path__ + "static/media/playVideo.e44b5835.png",
    width: 28,
    height: 31
});